setHtml()
window.addEventListener('resize', function () {
  setHtml()
})
function setHtml () {
  var width = document.documentElement.clientWidth
  document.querySelector('html').style.fontSize = 16 * (width / 375) + 'px'
}



// WEBPACK FOOTER //
// ./src/assets/scripts/flexible.js